import { href, redirect, RouteObject } from 'react-router';

import { ROUTES } from '~shared/routes';

import { RedirectIfAuthenticated } from '../components/redirect/RedirectIfAuthenticated';

export const authRoutes: RouteObject = {
  children: [
    {
      element: <RedirectIfAuthenticated />,
      children: [
        {
          path: ROUTES.auth.login,
          children: [
            {
              index: true,
              lazy: async () => {
                const { LoginPage } =
                  await import('../../pages/login/Login.page');

                return { Component: LoginPage };
              },
            },
          ],
        },
      ],
    },
    {
      path: ROUTES.auth.reset,
      children: [
        {
          index: true,
          lazy: async () => {
            const { ResetPage } = await import('../../pages/reset/Reset.page');

            return { Component: ResetPage };
          },
        },
        {
          path: ROUTES.auth.resetToken,
          lazy: async () => {
            const { ResetTokenPage } =
              await import('../../pages/reset/ResetToken.page');

            return { Component: () => <ResetTokenPage isOTP={false} /> };
          },
        },
      ],
    },
    {
      path: ROUTES.auth.definePassword,
      lazy: async () => {
        const { ResetTokenPage } =
          await import('../../pages/reset/ResetToken.page');

        return { Component: () => <ResetTokenPage isOTP /> };
      },
    },
    {
      path: '*',
      loader: ({ params }: { params: { pharmacyId?: string } }) => {
        return redirect(
          href(ROUTES.auth.login, { pharmacyId: params.pharmacyId! })
        );
      },
    },
  ],
};

export const cipAuthRoute = {
  path: ROUTES.auth.loginCip,
  children: [
    {
      index: true,
      element: <RedirectIfAuthenticated />,
      lazy: async () => {
        const { LoginCipPage } =
          await import('../../pages/login/LoginCip.page');

        return { Component: LoginCipPage };
      },
    },
  ],
};
